import { render, staticRenderFns } from "./Vol05.vue?vue&type=template&id=71e36f69&scoped=true&"
import script from "./Vol05.vue?vue&type=script&lang=js&"
export * from "./Vol05.vue?vue&type=script&lang=js&"
import style0 from "./Vol05.vue?vue&type=style&index=0&id=71e36f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e36f69",
  null
  
)

export default component.exports